export function watch() {

    let body = document.body;

    let header = document.getElementsByTagName('header')[0];
    let flux = document.getElementsByClassName('flux')[0];

    let footer = document.querySelectorAll('[footer_sticky_bottom]')[0];

    if(typeof flux === 'undefined' || typeof footer === 'undefined' || flux == null || footer == null) {
        return;
    }

    if (typeof footer !== 'undefined') {

        if (body.clientHeight < (header.offsetHeight + flux.offsetHeight + footer.clientHeight)) {
            flux.style.paddingBottom = footer.clientHeight + 'px';
        }

        footer.style.top = (body.clientHeight - footer.clientHeight) + 'px';
    }

    return true;
}